export default "__VITE_ASSET__IVgnaQQ2__"